import { render, staticRenderFns } from "./CompetitionCreate.vue?vue&type=template&id=1dee86f2&scoped=true&"
import script from "./CompetitionCreate.vue?vue&type=script&lang=js&"
export * from "./CompetitionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee86f2",
  null
  
)

export default component.exports